import React, { useEffect, useState, useMemo } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Backlink from "../../components/Backlink";
import CustomizedModal from "../../components/UI/CustomizedModal";
import { SlNote } from "react-icons/sl";

// Build breadcrumb paths based on current URL params
const getBreadcrumbPath = (params, index) => {
  const { pwsId, pwsKey, wellId, wellKey, visitId } = params;

  switch (index) {
    case 0: // Water System
      return pwsId && pwsKey ? `/pws/${pwsId}/${pwsKey}` : null;
    case 1: // Well
      return wellId && wellKey
        ? `/pws/${pwsId}/${pwsKey}/well/${wellId}/${wellKey}`
        : null;
    case 2: // Visit
      return visitId
        ? `/pws/${pwsId}/${pwsKey}/well/${wellId}/${wellKey}/visit/${visitId}`
        : null;
    default:
      return null;
  }
};

const WaterSystemRootLayoutPage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [showBackButton, setShowBackButton] = useState(null);
  const [header, setHeader] = useState(null);
  const [displayNotes, setDisplayNotes] = useState(false);
  const [modal, setModal] = useState(null);

  return (
    <section className="w-full">
      {modal && (
        <CustomizedModal
          title={modal?.title}
          message={modal?.message}
          onCancel={modal?.onCancel || (() => setModal(null))}
          onContinue={modal?.onContinue}
          size={modal?.size}
          askConfirmation={modal?.askConfirmation}
          continueButtonName={modal?.continueButtonName}
          cancelButtonName={modal?.cancelButtonName}
          modalButtonName={modal?.modalButtonName}
          isButtonDisable={modal?.isButtonDisable}
          content={modal?.content}
        />
      )}
      {showBackButton && <Backlink />}
      <section className="my-8 text-primary w-full">
        <div className="flex flex-col space-y-2 md:items-baseline md:flex-row md:justify-between">
          {header && (
            <h1 className="text-2xl md:text-3xl font-bold">
              {header.map((label, index) => {
                const path = getBreadcrumbPath(params, index);
                const isLast = index === header.length - 1;
                return (
                  <React.Fragment key={index}>
                    {index > 0 && <>&nbsp;&gt;&nbsp;</>}
                    {path && !isLast ? (
                      <Link
                        to={path}
                        className="hover:text-secondary hover:underline"
                      >
                        {label}
                      </Link>
                    ) : (
                      label
                    )}
                  </React.Fragment>
                );
              })}
            </h1>
          )}
          {displayNotes && (
            <p
              onClick={() => navigate(`${location.pathname}/notes`)}
              className="cursor-pointer text-lg md:text-xl font-bold md:ml-8 flex hover:text-secondary duration-100"
            >
              Notes
              <span className="ml-2 flex items-center">
                <SlNote />
              </span>
            </p>
          )}
        </div>
        <Outlet
          context={useMemo(
            () => ({
              setShowBackButton,
              setHeader,
              setDisplayNotes,
              setModal
            }),
            [
              setShowBackButton,
              setHeader,
              setDisplayNotes,
              setModal
            ]
          )}
        />
      </section>
    </section>
  );
};
export default WaterSystemRootLayoutPage;
